export interface ProductCustomer {
  id: string;
  productType: string;
  productKey: string;
  productDescription: string;
  default: string;
  partNo: string;
  currencyCode: string;
  currencySymbol: string;
  stdPrice: number;
  stdCutPrice: number;
}
